import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import {
  addAgentRetailer,
  getAllAgents,
} from "../../../services/agent.service";
import Select from "react-select";

export default function AgentRetailerAdd() {
  const { token } = useSelector((state) => state?.auth);
  // console.log("token", token);
  const [agents, setAgents] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState("");
  const navigate = useNavigate();

  const fetchAgents = async (page = false) => {
    try {
      const params = { page };
      const res = await getAllAgents(token, params);
      if (res && res.status >= 200 && res.status < 300) {        
        setAgents(res?.data); // Save the agent list in state
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch agents. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[Z]{1}[0-9A]{1}$/;

  const onSubmit = async (item) => {
    setIsLoading2(true);

    const data = {
      email: item.retailerEmail,
      mobile_number: item.retailerPhone,
      password: null,
      shop_name: item.shopName,
      PAN_number: item.panNumber,
      GST_number: item.gstNumber,
      owner_name: item.retailerName,
      address: item.retailerAddress,
      role: "Retailer",
      added_by: selectedAgentId,
    };

    // console.log(data);

    try {
      const res = await addAgentRetailer(token, data);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Added!",
          text: `${item.retailerName} Retailer has been added.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/agent/agent-retailer");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        const emailError = res?.data?.email ? `${res?.data?.email}<br>` : "";
        const mobileError = res?.data?.mobile_number
          ? `${res?.data?.mobile_number}`
          : "";
        Swal.fire("Error", `${emailError}${mobileError}`, "error");
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during adding retailer:", error);
      Swal.fire("Error", "An error occurred. Please try again later.", "error");
    } finally {
      setIsLoading2(false);
    }
  };

  const handleAgentChange = (selectedOption) => {
    const selectedAgent = agents?.find(
      (agent) => agent.fullname === selectedOption?.value
    );
    setSelectedAgentId(selectedAgent ? selectedAgent.customer_id : "");
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Retailer</h4>
                <Link to="/agent/agent-retailer">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="back"
                  />
                </Link>
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <Select
                          options={agents?.map((agent) => ({
                            value: agent.fullname,
                            label: agent.fullname,
                          }))}
                          {...register("agentName", {
                            required: "Agent Name is required",
                          })}
                          onChange={(selectedOption) => {
                            handleAgentChange(selectedOption);
                            setValue("agentName", selectedOption?.value);
                          }}
                          placeholder="Search and select agent"
                          isClearable // Allow clearing the selection
                          value={
                            watch("agentName")
                              ? {
                                  value: watch("agentName"),
                                  label: watch("agentName"),
                                }
                              : null
                          }
                        />

                        {errors.agentName && (
                          <p className="error">{errors.agentName.message}</p>
                        )}
                      </div>

                      {/* Retailer Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer name"
                          {...register("retailerName", {
                            required: "Name is required",
                          })}
                        />
                        {errors.retailerName && (
                          <p className="error">{errors.retailerName.message}</p>
                        )}
                      </div>

                      {/* Shop Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Shop Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter shop name"
                          {...register("shopName", {
                            required: "Shop Name is required",
                          })}
                        />
                        {errors.shopName && (
                          <p className="error">{errors.shopName.message}</p>
                        )}
                      </div>

                      {/* Retailer Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer email"
                          {...register("retailerEmail", {
                            required: "Email is required",
                            pattern: {
                              value: emailRegex,
                              message: "Please enter a valid email",
                            },
                          })}
                        />
                        {errors.retailerEmail && (
                          <p className="error">
                            {errors.retailerEmail.message}
                          </p>
                        )}
                      </div>

                      {/* Retailer Phone */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Contact Number</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Contact number"
                          maxLength={10}
                          {...register("retailerPhone", {
                            required: "Contact number is required",
                            pattern: {
                              value: /^[1-9][0-9]{9}$/,
                              message:
                                "Contact number must be 10 digits and not start with 0",
                            },
                          })}
                        />
                        {errors.retailerPhone && (
                          <p className="error">
                            {errors.retailerPhone.message}
                          </p>
                        )}
                      </div>

                      {/* GST Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">GST Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter GST Number"
                          maxLength={30}
                          {...register("gstNumber", {
                            pattern: {
                              // value: gstRegex,
                              message: "Please enter a valid GST number",
                            },
                          })}
                        />
                        {errors.gstNumber && (
                          <p className="error">{errors.gstNumber.message}</p>
                        )}
                      </div>

                      {/* PAN Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">PAN Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter PAN Number"
                          maxLength={30}
                          {...register("panNumber", {
                            pattern: {
                              // value: panRegex,
                              message: "Please enter a valid PAN number",
                            },
                          })}
                        />
                        {errors.panNumber && (
                          <p className="error">{errors.panNumber.message}</p>
                        )}
                      </div>

                      {/* Retailer Address */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Address</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer address"
                          {...register("retailerAddress", {
                            required: "Address is required",
                          })}
                        />
                        {errors.retailerAddress && (
                          <p className="error">
                            {errors.retailerAddress.message}
                          </p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          ADD RETAILER
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          ADDING RETAILER
                        </button>
                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
